<main class="contenedor">
  <header class="cabecera">
    <h1>Registros de contacto</h1>
    <p>Guarda nombres y números de teléfono.</p>
  </header>

  <section class="tarjeta" aria-labelledby="titulo-form">
    <h2 id="titulo-form">{{ editando() ? 'Editar registro' : 'Nuevo registro' }}</h2>
    <form [formGroup]="form" (ngSubmit)="guardar()" novalidate>
      <div class="campo">
        <label for="nombre">Nombre</label>
        <input id="nombre" type="text" formControlName="nombre" autocomplete="name"
               [attr.maxlength]="nombreMax + 50" aria-describedby="ayuda-nombre"
               [attr.aria-invalid]="form.controls.nombre.touched && form.controls.nombre.invalid">
        <div id="ayuda-nombre" class="error" aria-live="polite">
          @if (form.controls.nombre.touched && form.controls.nombre.errors; as e) {
            @if (e['required'] || e['vacio']) { El nombre es obligatorio. }
            @else if (e['maxlength']) { El nombre admite como máximo {{ nombreMax }} caracteres. }
          }
          @if (erroresServidor()['nombre']; as s) { {{ s }} }
        </div>
      </div>

      <div class="campo">
        <label for="telefono">Teléfono</label>
        <input id="telefono" type="text" inputmode="tel" formControlName="telefono" autocomplete="tel"
               [attr.maxlength]="telefonoMax + 20" aria-describedby="ayuda-telefono"
               [attr.aria-invalid]="form.controls.telefono.touched && form.controls.telefono.invalid">
        <div id="ayuda-telefono" class="error" aria-live="polite">
          @if (form.controls.telefono.touched && form.controls.telefono.errors; as e) {
            @if (e['required'] || e['vacio']) { El teléfono es obligatorio. }
            @else if (e['maxlength']) { El teléfono admite como máximo {{ telefonoMax }} caracteres. }
          }
          @if (erroresServidor()['telefono']; as s) { {{ s }} }
        </div>
      </div>

      @if (errorGuardado(); as msg) {
        <p class="alerta" role="alert">{{ msg }}</p>
      }

      <div class="acciones">
        <button type="submit" class="primario" [disabled]="guardando()">
          {{ guardando() ? 'Guardando…' : (editando() ? 'Guardar cambios' : 'Crear registro') }}
        </button>
        @if (editando()) {
          <button type="button" (click)="cancelarEdicion()" [disabled]="guardando()">Cancelar edición</button>
        }
      </div>
    </form>
  </section>

  <section class="tarjeta" aria-labelledby="titulo-lista">
    <h2 id="titulo-lista">Listado</h2>

    @if (aviso(); as a) {
      <p class="aviso" role="status">{{ a }}</p>
    }
    @if (errorBorrado(); as msg) {
      <p class="alerta" role="alert">{{ msg }}</p>
    }

    @if (cargando()) {
      <p role="status">Cargando registros…</p>
    } @else if (errorCarga()) {
      <p class="alerta" role="alert">{{ errorCarga() }}</p>
      <button type="button" (click)="cargar()">Reintentar</button>
    } @else if (registros().length === 0) {
      <p class="vacio">Todavía no hay registros. Crea el primero con el formulario.</p>
    } @else {
      <ul class="lista">
        @for (r of registros(); track r.id) {
          <li class="fila" data-testid="registro">
            <div class="datos">
              <span class="nombre">{{ r.nombre }}</span>
              <span class="telefono">{{ r.telefono }}</span>
            </div>
            @if (confirmandoId() === r.id) {
              <div class="acciones confirmacion" role="alertdialog" [attr.aria-label]="'Confirmar borrado de ' + r.nombre">
                <span>¿Eliminar a {{ r.nombre }}?</span>
                <button type="button" class="peligro" (click)="confirmarBorrado(r)" [disabled]="borrandoId() === r.id">
                  {{ borrandoId() === r.id ? 'Eliminando…' : 'Sí, eliminar' }}
                </button>
                <button type="button" (click)="cancelarBorrado()" [disabled]="borrandoId() === r.id">Cancelar</button>
              </div>
            } @else {
              <div class="acciones">
                <button type="button" (click)="editar(r)" [attr.aria-label]="'Editar ' + r.nombre">Editar</button>
                <button type="button" class="peligro-suave" (click)="pedirBorrado(r)" [attr.aria-label]="'Eliminar ' + r.nombre">Eliminar</button>
              </div>
            }
          </li>
        }
      </ul>
    }
  </section>
</main>
